import { Controller, Menu } from '@tencent/workbench';
import { MENU_CONFIGS, config } from './config';
import { ShapeFormatFeature } from '@framework/workbench/ui/shape-format/shape-format-feature';

@Controller({
    menuItems: MENU_CONFIGS,
})
export class ShapeFormatController {
    constructor(private readonly feature: ShapeFormatFeature) {
    }

    @Menu(config.id, 'onClick')
    public handleClick() {
        this.feature.callback();
    }
}
